export default __webpack_public_path__ + "static/media/intro_horse.7304b561.png";